/** Screen-noise tuning (plan 2026-10-06-screen-noise). Overridable per ProtectedImage. */
export const SCREEN_NOISE_STRENGTH = 0.15;
/** Grain cell edge in CSS px: the same look on every screen density. */
export const SCREEN_NOISE_GRAIN_PX = 3;
/** Per-frame threshold shift: the golden ratio spreads successive phases evenly over [0, 1). */
export const GOLDEN_STEP = 0.6180339887;

export interface Size {
  width: number;
  height: number;
}

/** The largest rectangle of aspect `ratio` (width / height) inside `box` — CSS object-fit: contain. */
export const fitContain = (box: Size, ratio: number): Size =>
  box.width / box.height > ratio
    ? { width: box.height * ratio, height: box.height }
    : { width: box.width, height: box.width / ratio };

/** The drawing buffer for a picture shown at `fitted` CSS px: device pixels, longest edge ≤ maxPx, at least 1×1. */
export const bufferSize = (fitted: Size, dpr: number, maxPx: number): Size => {
  const scale = Math.min(dpr, maxPx / Math.max(fitted.width, fitted.height, 1e-9));
  return {
    width: Math.max(1, Math.round(fitted.width * scale)),
    height: Math.max(1, Math.round(fitted.height * scale)),
  };
};

export const grainDevicePx = (grainCss: number, dpr: number): number => Math.max(1, grainCss * dpr);

export const nextPhase = (phase: number): number => (phase + GOLDEN_STEP) % 1;
